<template>
  <div class="main-content main-conent-maxheight main-content-rows page-home">
    <div class="home-head">
      <div class="title">农作物病虫害自动监测预警平台</div>
      <n-time></n-time>
      <div v-if="!isFullScreen" class="ctrls">
        <i class="el-icon-full-screen" @click="fullScreen"></i>
      </div>
    </div>

    <div class="main-rows">
      <div class="main-col main-left">
        <mete
          chart-id="meteorology-group-1"
          :cols="cols"
          :data="list"
          :group="group1"
          :loading="loading"
        ></mete>
      </div>

      <div class="main-col main-body">
        <div class="device-map-wrap" style="height: 100%;">
          <el-button-group class="home-map-btn-group">
            <el-button
              type="primary"
              icon="el-icon-map-location"
              :disabled="centerType === 'map'"
              @click="centerType = 'map'"
            >
            </el-button>
            <el-button
              type="primary"
              :disabled="centerType === 'monitor'"
              @click="centerType = 'monitor'"
            >
              <svg-icon iconClass="monitoring"></svg-icon>
            </el-button>
          </el-button-group>
          <n-map v-if="centerType === 'map'"></n-map>
          <camera v-else></camera>
        </div>
      </div>

      <div class="main-col main-right">
        <mete
          chart-id="meteorology-group-2"
          :cols="cols"
          :data="list"
          :group="group2"
          :loading="loading"
        ></mete>
      </div>
    </div>
  </div>
</template>

<script>
import NTime from './components/time'
// import Card from './components/card'
import NMap from './components/map'
import Camera from './components/camera'
import Mete from './components/mete/index'
import { list, cols } from '@/service/meteorology'
import { subtract, add } from '@/utlis/date'

export default {
  components: { NTime, NMap, Camera, Mete },
  name: 'Home',
  data() {
    return {
      centerType: 'map',
      clone: null,
      isFullScreen: false,
      loading: false,
      deviceId: null, // 当前气象站 id
      cols: [],
      list: [],
      group1: [
        ['风速', '风向'],
        ['空气温度', '空气湿度'],
        ['土壤温度', '土壤湿度']
      ],
      group2: [
        ['氮离子', 'pH值'],
        ['磷离子'],
        ['钾离子']
      ]
    }
  },
  async mounted() {
    this.$el.onfullscreenchange = this.exitFullScreen
    if (this.metes && this.metes[0]) {
      this.deviceId = this.metes[0].id
      this.loading = true
      await this.getCols()
      await this.getMeteData()
      this.loading = false
    }
  },
  methods: {
    fullScreen() {
      this.$el.requestFullscreen()
    },
    exitFullScreen() {
      this.isFullScreen = !this.isFullScreen
    },
    // 气象站 cols
    async getCols() {
      this.loadingCols = true
      const { data } = await cols(this.deviceId)
      this.cols = data
      this.loadingCols = false
    },
    async getMeteData() {
      const { data } = await list({
        companyId: this.companyId,
        deviceId: this.deviceId,
        begin: subtract(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
        end: add(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
        type: 'day'
      })
      this.list = data
    },
    async deviceChange(id) {
      this.deviceId = id
      await this.getCols()
      this.loading = true
      this.data = await this.getData()
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
.page-home {
  background-image: url('~@/assets/images/dashboard-bg.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .home-map-btn-group {
    position: absolute;
    top: 8px;
    left: 80px;
    z-index: 100;
    .el-button {
      background-color: rgba(51, 53, 56, 1);
      border: #656565;
      &.is-disabled {
        background-color: rgba(51, 53, 56, 0.7);
        color: #9aa8d4;
      }
    }
  }
  .device-map-wrap {
    position: relative;
    // padding-bottom: 40px;
    box-sizing: border-box;
  }
  .home-head {
    height: 110px;
    width: 90%;
    text-align: center;
    background-image: url('~@/assets/images/title-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    .title {
      font-size: 32px;
      line-height: 100px;
      text-align: center;
    }
    .time {
      position: absolute;
      right: 20px;
      top: 60px;
    }
    .ctrls {
      position: absolute;
      right: 20px;
      top: 4px;
      font-size: 1.2rem;
      color: rgba(0, 182, 252, 0.6);
      cursor: pointer;
    }
  }
  .main-col {
    margin: 0 20px;
    .home-card:not(:last-child) {
      // margin-bottom: 40px;
    }
  }
  .el-table {
    border: none;
    box-shadow: none;
  }
  .main-rows {
    height: calc(100% - 152px);
    width: 90%;
    display: flex;
    flex-direction: row;
  }
  .main-left,
  .main-right,
  .main-body {
    display: flex;
    flex-direction: column;
  }
  .main-left,
  .main-right {
    // flex: 1;
    width: 20%;
  }
  .main-body {
    flex: 2;
  }
  .device-picker {
    position: absolute;
    top: 8px;
    right: 20px;
    line-height: 24px;
    .el-input__inner {
      background-color: rgba(51, 53, 56, 0.5);
      border-color: #656565;
      color: #f3f1f1;
    }
    &.left {
      left: 20px;
      right: auto;
    }
  }
}
.device-picker__popper {
  background-color: #333538;
  border-color: #656565;
  .el-select-dropdown__item {
    color: #9aa8d4;
    &.selected {
      background-color: #656565;
      color: #fff;
    }
    &.hover {
      background-color: #656565;
    }
  }
  .popper__arrow {
    border-bottom-color: #656565 !important;
    &::after {
      border-bottom-color: #333538 !important;
    }
  }
}
</style>
